import { useMemo } from "react";
import useSWR from "swr";
import { keyBy } from "lodash";
import { fetchAiccTtsVoices } from "services/aiccLearningAssets";
import { AICC_SWR_CONFIG } from "../../hooks/swrConfig";

export function useAiccTtsVoices() {
  const { data, error, isLoading, mutate } = useSWR(["aicc/tts/voices"], () => fetchAiccTtsVoices(), AICC_SWR_CONFIG);

  const voices = useMemo(() => data ?? [], [data]);

  return {
    voices,
    voicesById: useMemo(() => keyBy(voices, "id"), [voices]),
    isLoading,
    isError: !!error,
    mutate,
  };
}
